import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import account from './account';
import rmi from './rmi';
import session from './session';

export default (history) => combineReducers({
  router: connectRouter(history),
  account,
  rmi,
  session,
});
